import { ArrayUtils } from "./ArrayUtils";
import { CoreType } from "./Type";
import cloneDeep from "lodash-es/cloneDeep";
import clone from "lodash-es/clone";
export class ObjectUtils {
  static isEqual(object0, object1) {
    if (CoreType.isBoolean(object0) && CoreType.isBoolean(object1)) {
      return object0 == object1;
    }
    if (CoreType.isNumber(object0) && CoreType.isNumber(object1)) {
      return object0 == object1;
    }
    if (CoreType.isString(object0) && CoreType.isString(object1)) {
      return object0 == object1;
    }
    if (CoreType.isObject(object0) && CoreType.isObject(object1)) {
      const keys0 = Object.keys(object0);
      const keys1 = Object.keys(object1);
      if (!ArrayUtils.isEqual(keys0, keys1)) {
        return false;
      }
      return JSON.stringify(object0) == JSON.stringify(object1);
    }
    return false;
  }
  static merge(object0, object1) {
    return Object.assign(object0, object1);
  }
  static clone(value) {
    return clone(value);
  }
  static cloneDeep(value) {
    return cloneDeep(value);
  }
}
